import script from "./SelectOptionV4.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectOptionV4.vue?vue&type=script&setup=true&lang=js"

import "./SelectOptionV4.vue?vue&type=style&index=0&id=2437cf8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2437cf8c"]])

export default __exports__